import { TransparenciaInformacaoAdicionalItem } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from '../comum/orgao.model';

export class TransparenciaInformacaoAdicionalGrupo extends BaseResourceModel {
    constructor(
        public id?: number,
        public nome?: string,
        public descricao?: string,
        public link?: string,
        public orgao?: Orgao,
        public itens?: TransparenciaInformacaoAdicionalItem[]
    ) {
        super();
    }

    static converteJson(json: any): TransparenciaInformacaoAdicionalGrupo {
        return Object.assign(new TransparenciaInformacaoAdicionalGrupo(), json);
    }
}